import { z } from 'zod';
import { optionalUuidString, requiredUuidString } from '../zod-helpers/index.js';
import { ratioFormSchema } from './ratio-form-schema.js';
export const createProductUomConversionFormSchema = z.object({
    stateId: optionalUuidString('Invalid state selection.'),
    uomId: requiredUuidString('UOM is required.', 'Invalid UOM selection.'),
    ratio: ratioFormSchema,
});
export function emptyProductUomConversionFormValues() {
    return { stateId: '', uomId: '', ratio: '' };
}
//# sourceMappingURL=create-form.js.map